import React from "react";
import ComingSoon from "../comingSoon/ComingSoon";

const LearningGrantsPage = () => {
  return (
    <div>
      <ComingSoon />
    </div>
  );
};

export default LearningGrantsPage;
